// Hooks
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

// Libs
import { CHANGE_YOUR_PLAN } from '@/lib/settings/subscriptionInvoices/steps';

import Icon from '@/components/base/Icon';
// Components
import LinkBase from '@/components/base/LinkBase';
import { Trans } from '@/components/tools/translation';

// Routes
import { SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

const DatepickerBannerDataRetention = () => {
    const { subscription } = useSubscription();
    // to be removed after successful YT review
    const { activeSocialProfile } = useActiveSocialProfile();

    if (!subscription?.data_retention_date) {
        return null;
    }

    if (activeSocialProfile?.social_network_type === 'youtube') {
        return null;
    }

    return (
        <p
            className="flex max-w-[328px] items-center gap-4 rounded-md bg-icoGray-100 p-2.5 font-GMedium text-xs text-icoGray-500 dark:bg-icoDarkMode-anthracite dark:text-icoDarkMode-wolf"
            data-test-id="datepicker-data-retention-banner">
            <Icon icon="crown" className="text-icoBlue" />
            <div>
                <Trans
                    i18nKey="commons:datepicker_data_retention_warning"
                    values={{ month: subscription.data_retention }}
                    components={{
                        link: (
                            <LinkBase
                                href={{
                                    pathname: SUBSCRIPTION_INVOICES,
                                    query: {
                                        step: CHANGE_YOUR_PLAN
                                    }
                                }}
                                className="text-icoBlue underline"
                            />
                        )
                    }}
                />
            </div>
        </p>
    );
};

export default DatepickerBannerDataRetention;
